export type ShopConfigEntry = {
  productId: number
  treeTypeId: number
  isPlusOnly: boolean
  asset: string
}

export type ShopProduct = {
  id: number
  price: number
}

export type ShopItem = {
  productId: number
  treeTypeId: number
  isPlusOnly: boolean
  asset: string
  price: number | null
  isOwned: boolean
  isLocked: boolean
}

export type ShopTab = 'bakery' | 'plus'

export type DeriveShopCatalogInput = {
  config: ShopConfigEntry[]
  products: ShopProduct[]
  unlockedTreeIds: Set<number>
  isPlus: boolean
  /** Optional tab filter. Omit to return both partitions. */
  tab?: ShopTab
}

export function deriveShopCatalog(input: DeriveShopCatalogInput): ShopItem[] {
  const productsById = new Map(input.products.map((p) => [p.id, p]))
  const items: ShopItem[] = []
  for (const entry of input.config) {
    if (input.tab === 'bakery' && entry.isPlusOnly) continue
    if (input.tab === 'plus' && !entry.isPlusOnly) continue
    const product = productsById.get(entry.productId)
    items.push({
      productId: entry.productId,
      treeTypeId: entry.treeTypeId,
      isPlusOnly: entry.isPlusOnly,
      asset: entry.asset,
      price: product?.price ?? null,
      isOwned: input.unlockedTreeIds.has(entry.treeTypeId),
      isLocked: entry.isPlusOnly && !input.isPlus,
    })
  }
  // Sort by price descending — items without a known price sink to the
  // bottom. Equal-priced items keep their original config order (Array.sort
  // is stable in modern JS engines).
  items.sort((a, b) => (b.price ?? -Infinity) - (a.price ?? -Infinity))
  return items
}
